import { NgModule } from '@angular/core';
import { MetascriptService } from './metascript.service';

@NgModule({
  providers: [MetascriptService],
})
export class MetaScriptModule {}
